// extracted by mini-css-extract-plugin
export default {"cartContainer":"mP","summarycontent":"nP","offset":"oP","leaf":"pP","summaryclosed":"qP","summaryheader":"rP","summaryitems":"sP","summaryprice":"tP","buttonopen":"uP","buttondown":"vP","summaryfixed":"wP","usdnotification":"xP","renew":"yP","promowrapper":"zP","ordersummarywrap":"AP","simplewrap":"BP"};
    if(module.hot) {
      // 1711717534229
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  